import { Pipe, PipeTransform } from '@angular/core';
import { AddressData } from '../../core/models/address-data';

@Pipe({
  name: 'formatAddress',
  standalone: true
})
export class FormatAddressPipe implements PipeTransform {
  transform(address: AddressData, locale: string = 'pt-BR'): string {
    if (!address) return '';

    const parts: string[] = [];

    if (locale.startsWith('pt')) {
      if (address.description) parts.push(address.description);
      if (address.number) parts[parts.length - 1] += `, ${address.number}`;
      if (address.complement) parts[parts.length - 1] += ` ${address.complement}`;
      if (address.neighborhood) parts.push(address.neighborhood);
      if (address.cityName) parts.push(address.cityName);
      if (address.stateAcronym || address.stateName) {
        parts[parts.length - 1] += ` - ${address.stateAcronym || address.stateName}`;
      }
      if (address.zipCode) parts.push(this.formatZipCode(address.zipCode, address.countryCode));
      if (address.countryCode && address.countryCode !== 'BR') parts.push(address.countryCode);
    } else {
      let street = '';
      if (address.number) street += `${address.number} `;
      if (address.description) street += address.description;
      if (address.complement) street += ` ${address.complement}`;
      if (street) parts.push(street.trim());
      
      if (address.neighborhood) parts.push(address.neighborhood);
      if (address.cityName) parts.push(address.cityName);
      if (address.stateAcronym || address.stateName) parts.push(address.stateAcronym || address.stateName);
      if (address.zipCode) parts.push(this.formatZipCode(address.zipCode, address.countryCode));
      if (address.countryCode) parts.push(address.countryCode);
    }
    
    return parts.join(', ');
  }

  private formatZipCode(zipCode: string, countryCode: string): string {
    if (countryCode === 'BR' && zipCode.length === 8) {
      return `${zipCode.substring(0, 5)}-${zipCode.substring(5)}`;
    }
    return zipCode;
  }
}
